module.exports = __webpack_public_path__ + "static/media/UniNeueBold-Italic.cf8ee0f7.woff2";